import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import TempTable from "./TempTable";

const Temperoraylist = () => {
    return (
        <Fragment>
            <TempTable mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default Temperoraylist;